/*
  RetroVerse UI fixes - Sep 2026. All in one file so they share one failure
  mode: if this does not load, nothing changes and the theme behaves as before.
  The CSS is injected by this script rather than shipped as a stylesheet on
  purpose, so it can never exist without the JS that makes the filter and
  search-clear rules safe.

  Nothing in this file changes what the shipping protection toggle does. Fix 13
  only stops the drawer scrolling itself back to the top afterwards.

   1. Country selector: dark grey links on a near-black panel. Repainted white.
   2. Sale badge icon: the inline SVG path had no fill so it fell back to black.
   3. Collection filter animated open then shut on load. Held at 0 with no
      transition until the shopper taps the header or a 1200ms timer fires.
   4. Sticky add-to-cart bar never became visible: the theme toggled .show but
      computed opacity stayed 0. The reveal is keyed off .show instead.
   5. Policy pages printed the title twice, and that title was the only spacing
      above the content, so the spacing is restored explicitly.
   6. Cart variant name was unreadably small.

      THE TRAP, do not undo this: the visible text is NOT in .product-option,
      it is in the dt and dd inside it. On phones the theme ships a rule
      setting .cart-drawer .product-option dt and dd to 6px under a max-width
      767px media query. Styling only the wrapper makes the wrapper compute
      14px while the text a shopper reads stays at 6px.

      Sizes differ by width on purpose. The drawer's product title is 19px on
      desktop but drops to 12px on phones, so a flat 14px variant line ends up
      louder than the title it belongs to. 14px desktop, 11px mobile.

      s.cart-item__old-price also carries .product-option, so it is excluded.
   7. Cart upsell photos sat in a thick grey frame. The frame is the image's own
      8px padding over the column's #f7f7f7 plate, not a border, so it is cut to
      2px and the photo gets the space back.
   8. The PDP game search had no way to clear it. Clear button added below.
   9. CHOOSE YOUR BUNDLE wrapped to two lines in the desktop sticky bar.
  10. Cart page: discount banner hidden, and the Save badges given the drawer's
      light purple pill. On phones that column is only 68px wide, so the pill
      drops to 11px and nowrap or it breaks into "Save" over "$70".

      The order-total discount pill is deliberately NOT restyled. It was tried
      in the same light purple and looked worse than the black it ships with.

      Everything here is scoped to #main-cart-items so the drawer, which
      renders the same classes, is never touched.

      DO NOT restyle the cart item table here. An earlier attempt padded the
      cells, which looks right on desktop but wrecks the phone layout: below
      750px the theme lays those cells out as a CSS grid, so cell padding
      inflated every row by about 70% and squeezed the price column until the
      amounts wrapped mid-number. The table is left as the theme built it.

      The colours need !important. The cart sections write their own colour
      settings out as !important inline rules, which beat even an id selector.
  11. The game search sub-line wrapped mid-link on phones, leaving "Browse" on
      one line and "them all." orphaned on the next. The link is now nowrap so
      it moves as one unit.
  12. The last letter of the guarantee section's gradient heading was clipped.

      The heading carries letter-spacing -2px, which the browser subtracts
      after EVERY character including the final one, so the element's box ends
      2px inside the last glyph. With normal text nobody notices. With
      background-clip:text the gradient only paints inside that box, so the
      tail of the last letter gets no paint and reads as cut off.

      The theme already solved this everywhere else - the hero and the product
      comparison headings both carry padding-right:4px !important for exactly
      this reason. The guarantee section was missed.

      The selector has to include .guarantee-section__heading. The section
      writes its own spacing out as an inline !important rule at two classes of
      specificity, and that rule sits later in the document than this injected
      stylesheet, so matching its specificity is not enough - a third class is
      needed to outrank it.
  13. The drawer jumped to the top on every cart change. Separate IIFE at the
      bottom of this file, with its own explanation.
  14. Cart remove icon was a heavy solid black trash can. Swapped for a light
      outline one to match UpCart, at 16px.

      Done as a CSS background on the wrapper span rather than by replacing the
      SVG in JS. The drawer re-renders its whole item list from the server on
      every cart change, so any node swapped in by script is thrown away within
      the second - a background image on a class survives every re-render for
      free, with no observer to maintain.

      ICON_PX is the one place to change the size. The stroke width lives in
      the 24-unit viewBox, so it scales with the box: at 16px the 1.6 stroke
      renders near 1.07px, which is what makes it read as light rather than
      drawn-on. Raising ICON_PX thickens the line to match.
  15. Removing a cart item showed a spinner for over half a second. Now the row
      goes immediately. Its own IIFE at the bottom, with the measurements.
*/
(function () {
  'use strict';

  var ICON_PX = 16;

  var TRASH = 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'24\' height=\'24\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23282a2e\' stroke-width=\'1.6\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpath d=\'M3 6h18\'/%3E%3Cpath d=\'M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6\'/%3E%3Cpath d=\'M18.5 6l-.8 13.1A2 2 0 0 1 15.7 21H8.3a2 2 0 0 1-2-1.9L5.5 6\'/%3E%3Cpath d=\'M10 10.5v6\'/%3E%3Cpath d=\'M14 10.5v6\'/%3E%3C/svg%3E")';

  var CSS = [
    /* ---- 1. country selector ---- */
    '.disclosure__list-wrapper.country-selector{',
    '  background:#ffffff !important;border:1px solid #e5e5e5;',
    '  box-shadow:0 8px 24px rgba(0,0,0,.12);',
    '}',
    '.country-selector .disclosure__list,',
    '.country-selector .disclosure__item,',
    '.country-selector .disclosure__link,',
    '.country-selector .localization-form__currency{color:#25282a !important;}',
    '.country-selector .disclosure__link:hover,',
    '.country-selector .disclosure__link:focus{',
    '  background:#f5f2fd !important;color:#6e32c9 !important;',
    '}',
    '.country-selector .disclosure__link[aria-current="true"]{',
    '  color:#6e32c9 !important;font-weight:600;',
    '}',
    '.country-selector input[type="text"],',
    '.country-selector input[type="search"]{',
    '  background:#ffffff !important;color:#25282a !important;',
    '  border:1px solid #dedede !important;',
    '}',

    /* ---- 2. sale badge icon ---- */
    '.sale-badge svg path,',
    '.sale-badge-icon svg path{fill:currentColor !important;}',
    '.sale-badge-icon{color:inherit;}',

    /* ---- 3. collection filter flash ---- */
    '@media (max-width:990px){',
    '  .sidebar-filters:not(.collapsed):not(.rv-open) .sidebar-filters__content{',
    '    max-height:0 !important;padding:0 16px !important;transition:none !important;',
    '  }',
    '}',

    /* ---- 4. sticky add to cart reveal ---- */
    'div.sticky-add-to-cart{pointer-events:none;}',
    'div.sticky-add-to-cart.show{',
    '  opacity:1 !important;transform:none !important;pointer-events:auto !important;',
    '}',

    /* ---- 5. policy pages ---- */
    '.shopify-policy__title{display:none !important;}',
    '.shopify-policy__container{padding-top:48px !important;}',
    '@media (max-width:749px){.shopify-policy__container{padding-top:28px !important;}}',

    /* ---- 6. cart variant name: the dt and dd carry the text ---- */
    '.cart-drawer .product-option:not(.cart-item__old-price),',
    '.cart-drawer .product-option dt,',
    '.cart-drawer .product-option dd,',
    '.cart-item .product-option:not(.cart-item__old-price),',
    '.cart-item .product-option dt,',
    '.cart-item .product-option dd{',
    '  font-size:14px !important;font-weight:500 !important;',
    '  line-height:1.4 !important;color:#3f3f4a !important;opacity:1 !important;',
    '}',
    '@media (max-width:767px){',
    '  .cart-drawer .product-option:not(.cart-item__old-price),',
    '  .cart-drawer .product-option dt,',
    '  .cart-drawer .product-option dd,',
    '  .cart-item .product-option:not(.cart-item__old-price),',
    '  .cart-item .product-option dt,',
    '  .cart-item .product-option dd{font-size:11px !important;}',
    '}',

    /* ---- 7. cart upsell image frame ---- */
    '.cart-drawer .upsell-product-img,',
    '.upsell-product-img{padding:2px !important;}',

    /* ---- 8. PDP game search clear button ----
       The wrapper takes over the flex sizing the input had as a direct child of
       .rv-gs__form. The id selector outranks .rv-gs__form button, so the
       theme's black search-button styling never lands on this one. */
    '.rv-clear-wrap{position:relative;display:block;flex:1 1 auto;min-width:0;}',
    '.rv-clear-wrap input{width:100%;padding-right:38px;}',
    '#rvPdpClear{',
    '  position:absolute;top:50%;right:10px;transform:translateY(-50%);',
    '  width:20px;height:20px;padding:0;border:0;border-radius:50%;',
    '  display:inline-flex;align-items:center;justify-content:center;',
    '  background:#d9d9de;color:#ffffff;cursor:pointer;line-height:0;',
    '}',
    '#rvPdpClear:hover,#rvPdpClear:focus-visible{background:#b9b9c2;}',
    '#rvPdpClear[hidden]{display:none;}',

    /* ---- 9. sticky bar button wrapped on desktop ---- */
    '@media (min-width:750px){',
    '  .sticky-add-to-cart__button{',
    '    white-space:nowrap !important;',
    '    padding-left:26px !important;padding-right:26px !important;',
    '  }',
    '}',

    /* ---- 10. cart page ---- */
    'cart-items > .page-width > .discount-banner{display:none !important;}',

    '#main-cart-items .gb-price-drawer-saving{',
    '  display:inline-block !important;width:auto !important;',
    '  background:#f8f5fe !important;color:#6e31c9 !important;',
    '  font-size:13px !important;font-weight:700 !important;',
    '  padding:2px 8px !important;border-radius:50px !important;',
    '  white-space:nowrap !important;margin-top:4px;',
    '}',
    '@media (max-width:749px){',
    '  #main-cart-items .gb-price-drawer-saving{',
    '    font-size:11px !important;padding:2px 6px !important;margin-top:2px;',
    '  }',
    '}',

    /* ---- 11. game search sub-line broke mid-link on phones ---- */
    '.rv-gs__sub a{white-space:nowrap;}',

    /* ---- 12. clipped last letter on the guarantee gradient heading ----
       Three classes on purpose. See the note at the top of this file. */
    '.guarantee-section .guarantee-section__heading .accent-text{',
    '  padding-right:4px !important;',
    '}',

    /* ---- 14. outline trash icon ----
       The theme ships a solid filled trash can. Hide that path and paint an
       outline one on the wrapper span instead, so the icon survives the
       drawer's server re-render on every cart change.

       The display:inline-block !important here is load-bearing for fix 15 as
       well: on click the theme sets this span to inline style display:none to
       swap in its spinner. Author !important outranks a non-important inline
       style, so the trash can simply stays put. */
    '.cart-drawer .cart-remove-button .gb-cart-del-img svg,',
    '#main-cart-items .cart-remove-button .gb-cart-del-img svg,',
    '.cart-item .cart-remove-button .gb-cart-del-img svg{',
    '  display:none !important;',
    '}',
    '.cart-drawer .cart-remove-button .gb-cart-del-img,',
    '#main-cart-items .cart-remove-button .gb-cart-del-img,',
    '.cart-item .cart-remove-button .gb-cart-del-img{',
    '  display:inline-block !important;',
    '  width:' + ICON_PX + 'px !important;height:' + ICON_PX + 'px !important;',
    '  background-image:' + TRASH + ' !important;',
    '  background-repeat:no-repeat !important;',
    '  background-position:center !important;',
    '  background-size:' + ICON_PX + 'px ' + ICON_PX + 'px !important;',
    '  opacity:.75;transition:opacity .15s ease;',
    '}',
    '.cart-remove-button:hover .gb-cart-del-img{opacity:1;}',

    /* ---- 15. no spinner on remove ----
       Measured on the drawer: 11ms after the click the theme sets a
       div.spin-animation to display:block and hides the trash icon, and the
       item list does not re-render until 634ms. That is roughly six tenths of
       a second of spinning for what reads to a shopper as an instant action.
       The spinner is suppressed here and the row is hidden on click by the
       IIFE at the bottom of this file. */
    '.cart-remove-button .spin-animation,',
    'cart-remove-button .spin-animation{display:none !important;}'
  ].join('\n');

  function injectCSS() {
    if (document.getElementById('rv-ui-fixes')) return;
    var s = document.createElement('style');
    s.id = 'rv-ui-fixes';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function releaseFilters() {
    var bars = document.querySelectorAll('.sidebar-filters');
    for (var i = 0; i < bars.length; i++) bars[i].classList.add('rv-open');
  }

  function buildSearchClear() {
    var input = document.getElementById('rvPdpQ');
    if (!input || document.getElementById('rvPdpClear')) return;
    var form = input.parentElement;
    if (!form) return;

    /* Wrap rather than rebuild. Moving the node keeps its id and every listener
       the block's own script already attached to it. */
    var wrap = document.createElement('span');
    wrap.className = 'rv-clear-wrap';
    form.insertBefore(wrap, input);
    wrap.appendChild(input);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'rvPdpClear';
    btn.setAttribute('aria-label', 'Clear search');
    btn.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    wrap.appendChild(btn);

    function sync() { btn.hidden = !input.value; }

    function blankStatus() {
      var st = document.querySelector('.rv-gs__status');
      if (st) st.textContent = '';
    }

    input.addEventListener('input', sync);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      input.value = '';
      sync();
      input.focus();
      /* A real event so the block's own search reruns and empties its results. */
      input.dispatchEvent(new Event('input', { bubbles: true }));
      blankStatus();
      setTimeout(blankStatus, 400);
    });

    sync();
  }

  function start() {
    injectCSS();
    buildSearchClear();

    /* Capture phase so we run before the theme's own handler toggles .collapsed. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('.sidebar-filters__header')) releaseFilters();
    }, true);

    setTimeout(releaseFilters, 1200);
  }

  injectCSS();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---- 13. drawer scroll jumped to the top on every cart change ----

   The theme re-renders the cart drawer from a fresh server response after any
   cart mutation. That replaces the scroll container, and a brand new element
   starts at scrollTop 0. Measured on the store: scroll position 253px, tap the
   shipping protection toggle, and about 780ms later it snaps to 0. The shopper
   gets yanked from the toggle they just tapped back up to the top of the cart
   while the contents re-flow. That is the spazzing.

   The toggle itself was never broken - adding and removing it moves the cart
   between 3 and 4 items correctly every time. Only the scroll position was
   wrong.

   Sep 14 2026: the first version put the position back from a 40ms polling
   timer, i.e. after the reset had already been painted, so the drawer still
   flashed to the top for a frame or two before snapping back. It now restores
   from a MutationObserver callback, which runs once the new content is in the
   DOM but before the browser paints it. The reset is never drawn.

   The position is remembered on any tap inside the drawer and only put back
   if it actually got reset, within 2.5s, and never after the shopper has
   scrolled themselves. Its own IIFE so a throw in here cannot take the fixes
   above down with it. */
(function () {
  'use strict';

  function scroller() {
    var d = document.querySelector('cart-drawer, .cart-drawer');
    if (!d) return null;
    var all = d.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var e = all[i];
      if (e.scrollHeight > e.clientHeight + 20) {
        var oy = getComputedStyle(e).overflowY;
        if (oy === 'auto' || oy === 'scroll') return e;
      }
    }
    return null;
  }

  var wanted = 0, deadline = 0, userMoved = false;

  function armed() {
    return wanted > 0 && !userMoved && Date.now() <= deadline;
  }

  function restore() {
    if (!armed()) return;
    var sc = scroller();
    if (!sc || sc.scrollTop !== 0) return;
    sc.scrollTop = Math.min(wanted, sc.scrollHeight - sc.clientHeight);
  }

  function arm() {
    var sc = scroller();
    if (!sc || sc.scrollTop <= 0) return;
    wanted = sc.scrollTop;
    userMoved = false;
    deadline = Date.now() + 2500;
  }

  /* Any tap inside the drawer can mutate the cart: the shipping protection
     toggle, quantity steppers, remove buttons, an upsell Add. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('cart-drawer, .cart-drawer')) arm();
  }, true);

  /* If the shopper scrolls on purpose while armed, leave them alone. */
  ['wheel', 'touchmove'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      if (armed()) userMoved = true;
    }, { passive: true });
  });

  function observe() {
    var d = document.querySelector('cart-drawer');
    if (!d || !window.MutationObserver) return;
    new MutationObserver(restore).observe(d, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();

/* ---- 15. remove an item without the wait ----

   Measured on the drawer, from the click:

       11ms   div.spin-animation -> display:block, trash icon -> display:none
      634ms   the item list finally re-renders and the row disappears

   So the shopper watched a spinner for six tenths of a second to delete a line
   from their own cart. The CSS above stops the spinner ever showing; this hides
   the row itself the instant the button is pressed, so the action reads as
   immediate while the request finishes in the background.

   This is optimistic, and safely so: the theme replaces the whole list from the
   server about 600ms later, so if the removal ever failed the row comes back on
   its own. Nothing here talks to the cart - the theme's own handler still does
   the actual work, untouched. (Removing the LAST product is the exception:
   rv-cart-protection-cleanup.js takes that one over so the empty state shows
   at once.)

   Capture phase so the row is hidden on the way down, before the theme's
   handler starts its request. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.cart-remove-button, cart-remove-button');
    if (!btn) return;

    var row = btn.closest('.cart-item, tr.cart-item, .cart-drawer__item');
    if (!row) return;

    row.style.setProperty('display', 'none', 'important');
  }, true);
})();
